import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './OptoutTop.css';

const Optout = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [selected, setSelected] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // メールアドレス入力の更新
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // チェックボックスの選択制御（どちらか一方のみ選択可能）
  const handleChange = (e) => {
    setSelected(e.target.value);
  };

  const handleSubmit = async (event) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    event.preventDefault();
  
    if (!selected || !email) {
      alert("メールアドレスと選択項目を入力してください");
      return;
    }
  
    try {
      const response = await fetch("https://0d17oeeh23.execute-api.ap-northeast-1.amazonaws.com/prod/optoutHandler-prod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          option: selected,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        switch (result.action) {
          case "submit":
            navigate("/SubmitComplete"); 
            break;
        } 
      } else {
        switch (result.errorType) {
          case 'EMAIL_NOT_FOUND':
            navigate("/SubmitNotFoundEmail");
            break;
          case 'UNEXPECTED_ERROR':
            navigate("/UnecpectedError");
            break;
          case 'ALREADY_EXISTS':
            navigate("/SubmitErrorOptout");
            break;
          case 'ALREADY_QUIT':
            navigate("/SubmitErrorQuit");
            break;
          default:
            navigate("/UnexpectedError");
            break;
        }
      }
    } catch (error) {
      navigate("/UnexpectedError");
    }
  };
  
  
  return (
    <div className="wrapper">
      <div className="form_wrapper">
        <h2 className="optout">らくらく連絡網メルマガ配信停止フォーム</h2>

        <p className="mail_attention">
          ※お知らせ：事業譲渡により、らくらく連絡網メールマガジンの運営会社は 2026 年 1 月 1 日より株式会社イオレから株式会社ユーフォリアへ変更となります。なお、サービス内容や各種お手続きについて変更はございません。
        </p>
        <p className="mail_explain"></p>

        <p className="mail_explain">
          らくらく連絡網メルマガの配信停止メールを、入力されたメールアドレスに送信いたします。
        </p>
        <p className="mail_explain">
          メールアドレスは、半角（英字は半角小文字）にてご入力ください。
        </p>

        <div className="send_form">
          <form id="emailForm" onSubmit={handleSubmit}>
            <div className="checkbox-group">
              <input 
                type="checkbox"
                id="optout"
                name="option"
                value="optout"
                checked={selected === "optout"}
                onChange={handleChange}
              />
              <label className="optout" htmlFor="optout">
                メルマガの配信停止をする（らくらく連絡網の退会はしません）
              </label>
            </div>
            <div className="checkbox-group">
              <input 
                type="checkbox"
                id="quit"
                name="option"
                value="quit"
                checked={selected === "quit"}
                onChange={handleChange}
              />
              <label htmlFor="quit">らくらく連絡網を退会する（退会後はメルマガ配信も停止します）</label>
            </div>

            <div className="mailaddress">
              <label className="mail_p">メールアドレス:</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="メールアドレスを入力"
                required
              />
            </div>

            <div className="consent">
              <p className="consent_p">
                <a href="/Terms.html" target="_blank" rel="noopener noreferrer">利用規約</a>
              </p>
              <p className="consent_p">
                <a href="/PersonalInfomation.html" target="_blank" rel="noopener noreferrer">個人情報の取り扱いについて</a>
              </p>
              <div className="checkbox-group">
                <input 
                  type="checkbox"
                  name="consent"
                  value="consent"
                  required
                />
                <label className="mail_p">利用規約・個人情報の取り扱いに同意する</label>
              </div>
            </div>

            <div className="btn_width">
              <button type="submit" className="send_button btn btn-primary" disabled={!selected || !email || isSubmitting}>
                確認メールを送信
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Optout;
